import { Button } from '@gisce/oficina-virtual-components';
import { ArrowBack, ArrowForward } from '@mui/icons-material';
import { Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { isRouteErrorResponse, useNavigate, useRouteError } from 'react-router-dom';
import { FC } from 'react';
import authActions from "../Authentication/actions";
import { useDispatch } from 'react-redux';
import ErrorLayout from './components/ErrorLayout';

const ErrorRoutePage: FC = () => { 
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const possibleRouteError = useRouteError();

  const getErrorTitleFromCode = (statusCode: number): string => {
    switch (statusCode) {
      case 403: return t('common:text.error.auth_page_title');
      default: return t('common:text.error.page_title');
    }
  }

  const handleContinue = () => {
    dispatch(authActions.clearError());
  }

  const error = isRouteErrorResponse(possibleRouteError) && possibleRouteError;
  
  return error && <ErrorLayout
    errorTitle={getErrorTitleFromCode(error.status)}
    imageSrc={"/images/error/crash/lightpole.jpg"}
    errorDetailComponent={<>
      <Typography variant="h6" pb={1}>
        {error.status && t('common:text.error.code_message', {"errorCode": error.status})}
      </Typography>
      <Typography variant="body1">
        {error.status === 404 && t('common:text.error.notfound_view_message')}
        {[403].includes(error.status) && t('common:text.auth_error_view_subtitle')}
      </Typography>
      <Typography variant="body1">
        {t('common:text.error.link_text')}
      </Typography>
    </>}
    redirectComponent={
      <Stack
        direction="row"
        justifyContent="flex-start"
        alignItems="center"
        sx={{marginTop: 3}}
        spacing={2}
      >
        {[403].includes(error.status) &&
          <Button 
            variant="contained" 
            color="primary"
            startIcon={
              <ArrowForward />
            }
            onClick={() => handleContinue()}
          >
          {t('common:text.continue')}
        </Button>}

        {/* Si vull el botó 403 es pot navegar amb window.location.href perquè recarrega la pàgina. evitaria errors */}
        {[404].includes(error.status) &&
          <Button 
            variant="contained" 
            color="primary"
            startIcon={
              <ArrowBack />
            }
            onClick={() => navigate("/")}
          >
            {t('common:text.error.go_back_home_button')}
          </Button>}
      </Stack>
    }
  />
}

export default ErrorRoutePage;
